import { CaretLeft, CaretRight, Check as CheckGlyph, MagnifyingGlass, MapPin, PencilSimple, Warning as WarningTriangle, X } from "@phosphor-icons/react";

/** Dismiss a sheet, dialog or overlay, or clear a field. Icon size `md` (CloseButton picks it). */
export const Close = X;

/** Search fields and search entry points. */
export const Search = MagnifyingGlass;

/** A place: store or delivery address. */
export const Pin = MapPin;

/** Done, confirmed, selected. */
export const Check = CheckGlyph;

/** Back navigation in headers and over images. Icon size `lg`. */
export const Back = CaretLeft;

/** Edit an entered value (address, notes, schedule). */
export const Edit = PencilSimple;

/** Attention: warnings, denied or not-found states; a triangle, so it never reads as the round `Info`. */
export const Warning = WarningTriangle;

/** Row and rail chevron pointing forward. Icon size `sm`. */
export const Chevron = CaretRight;
